import { ClassTypeOptions, ra, ra_property } from '@cundd/rest-adapter';

@ra(ClassTypeOptions.AddUnknownFields)
export class Contact {
    @ra_property()
    public referenceId: string = '';

    @ra_property()
    public firstName: string = '';

    @ra_property()
    public lastName: string = '';

    @ra_property()
    public email: string = '';

    @ra_property()
    public telephone: string = '';

    @ra_property()
    public mobile: string = '';

    @ra_property()
    public street: string = '';

    @ra_property()
    public city: string = '';

    @ra_property()
    public zip: string = '';

    @ra_property()
    public country: string = '';
}
